import { Tabs, Modal } from "ant-design-vue";
import Vue from "vue";
Vue.use(Tabs);
Vue.use(Modal);
Vue.prototype.$c = Modal.confirm;
